import {
  BenefitsBar,
  FaqSection,
  FinalCta,
  HeroSection,
  Navbar,
  StepsSection,
  Testimonial,
  WhyMogesappSection,
} from '@/components/landing'
import type { Testimonial as TestimonialType } from '@/components/landing/Testimonials'
import ibrahim_sow from '/ibrahim_sow.png'
import amadou_niangadou from '/amadou_niangadou.png'
import fatou from '/fatou.png'

const testimonials: TestimonialType[] = [
  {
    image: ibrahim_sow,
    name: 'Ibrahima Sow',
    role: 'Gérant magasin de pagne',
    text: 'MOGESAPP a facilité le travail, surtout la gestion des encaissements et des dettes.',
  },
  {
    image: amadou_niangadou,
    name: 'Amadou Niangadou',
    role: 'Propriétaire magasin',
    text: "L'application nous facilite grandement le travail au quotidien.",
  },
  {
    image: fatou,
    name: 'Fatou',
    role: 'Gérante de supérette',
    text: 'Depuis MOGESAPP, nos ventes sont mieux suivies et nous avons réduit nos pertes de 30 %.',
  },
  {
    name: 'Paul',
    role: 'Responsable magasin',
    text: 'On visualise nos bilans en temps réel. On gagne un temps fou.',
  },
  {
    name: 'Amina',
    role: 'Gérante supermarché',
    text: 'Le support est hyper réactif, même tard le soir.',
  },
]

export default function Homepage() {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <WhyMogesappSection />
      <BenefitsBar />
      <StepsSection />
      <Testimonial items={testimonials} />
      <FaqSection />
      <FinalCta />
    </div>
  )
}
